import { useSyncExternalStore } from 'react';

const query = window.matchMedia('(max-width: 1000px)');
const subscribe = (callback: () => void) => {
  query.addEventListener('change', callback);
  return () => query.removeEventListener('change', callback);
};

export default function useCompactLayout() {
  return useSyncExternalStore(subscribe, () => query.matches);
}
